export function isInPage(node: any): boolean {
  return node === document.body ? false : document.body.contains(node);
}
